import { useContext, type ReactNode } from 'react';
import type { IActionPerformer } from '@models/actions/IBaseAction';
import UserHoverCard from '@molecules/UserHoverCard/UserHoverCard';
import UserAvatar from '@molecules/UserAvatar/UserAvatar';
import { useAvatarMeta } from '@molecules/UserAvatar/useAvatarMeta';
import { DocumentRuntimeContext } from '@/context/DocumentRuntimeContext';
import './ActionParticipant.scss';

export interface IActionParticipantProps {
    performer: IActionPerformer;
    children: ReactNode;
    context?: string;
}

/** Самостоятельный триггер контакта рядом с действиями, вне их области клика. */
const ActionParticipant = ({ performer, children, context }: IActionParticipantProps) => {
    const runtime = useContext(DocumentRuntimeContext);
    const userKey = runtime.mode === 'supportPreview' ? undefined : performer.key;
    const meta = useAvatarMeta(userKey);

    return (
        <div className="action-participant">
            <div className="action-participant__identity">
                <UserAvatar
                    userKey={userKey}
                    name={performer.name}
                    hasImage={meta?.hasImage ?? false}
                    photoVersion={meta?.photoVersion ?? undefined}
                    size={30}
                />
                <div className="action-participant__text">
                    <UserHoverCard
                        key={userKey ?? performer.name}
                        userKey={userKey}
                        fallbackName={performer.name}
                        position="bottom-start"
                        zIndex={1200}
                        interactive
                    >
                        <span className="action-participant__name">{performer.name}</span>
                    </UserHoverCard>
                    {context && <span className="action-participant__context">{context}</span>}
                </div>
            </div>
            <div className="action-participant__actions">{children}</div>
        </div>
    );
};

export default ActionParticipant;
